import { api } from './fetch/api';

export default class LeadExcelExportService {
    async fetchExport(token: string) {
        const resp = await fetch(api.leadsExcelExport, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        let filename: string;
        let content;
        if (resp.status === 200 || resp.status === 304) {
            const contentHeader = resp.headers.get('content-disposition');
            if (contentHeader) {
                filename = contentHeader.split('=')[1];
            }
            content = Promise.resolve(resp.blob());
        } else {
            console.error(resp);
            return;
        }

        content
            .then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => console.error(err));
    }
}
